// Mock data for Videre Scire consulting website

export const profileData = {
  name: "Martin E. Palacios",
  title: "Global Technology & Cybersecurity Executive | vCIO | vCISO | Digital Transformation Leader",
  phone: "+1 604-907-1963",
  email: "martin@viderescire.com",
  linkedin: "https://www.linkedin.com/in/mep9000",
  logo: "https://customer-assets.emergentagent.com/job_videre-consulting/artifacts/7fl5a8ef_VS%20LOGO%20Color.PNG",
  summary: "Senior executive with 20+ years of experience leading IT, cybersecurity, and digital transformation initiatives for global enterprises. Proven ability to align technology strategies with business objectives, deliver complex programs, and enable operational efficiency. Board-level experience and top-tier consulting background. Driving business resilience, operational excellence, and financial performance through technology, cybersecurity, and cultural transformation."
};

export const companyInfo = {
  name: "Videre Scire",
  tagline: "To see clearly is to know wisely.",
  vision: "To be the trusted advisor to boards and executive management, providing clarity, independent oversight, and dissenting perspective in technology-driven transformations — ensuring organizations reduce risk, control costs, and overcome cultural and change management barriers in ERP, cybersecurity, and AI adoption.",
  mission: "Videre Scire exists to guide leaders through complex digital decisions with impartial advice and disciplined oversight."
};

export const coreValues = [
  { title: "Independence", description: "Impartial oversight, free from vendor bias" },
  { title: "Accountability", description: "Holding consultants and outsourcers to board-level standards" },
  { title: "Foresight", description: "Anticipating risks in ERP, cybersecurity, and AI before they materialize" },
  { title: "Resilience", description: "Strengthening organizations against both technical and cultural failure points" },
  { title: "Integrity", description: "Acting as the voice of dissent when needed" },
  { title: "Innovation with Guardrails", description: "Championing leading-edge cyber assurance and AI adoption with ROI first mentality" }
];

export const services = [
  {
    title: "ERP Mega Projects",
    description: "Board-level oversight for complex ERP transformations. Reducing risk and cost by addressing root causes of failure.",
    details: [
      "Over-customization prevention",
      "Vendor-driven agendas mitigation",
      "Strong governance implementation",
      "Realistic timelines and budgets",
      "Cultural resistance management",
      "Ensuring ERP programs stay disciplined, aligned, and sustainable"
    ]
  },
  {
    title: "Cybersecurity Assurance",
    description: "Going beyond compliance to deliver leading-edge resilience strategies.",
    details: [
      "Threat readiness frameworks",
      "Data Loss Prevention (DLP) programs",
      "Board and top management accountability",
      "Safeguarding digital assets",
      "Post-breach recovery strategies"
    ]
  },
  {
    title: "AI Adoption & Data Assurance",
    description: "Setting up guardrails for ethical and transparent use of AI.",
    details: [
      "Ethical AI guardrails",
      "DLP principles integration",
      "Measurable ROI frameworks",
      "Responsible innovation",
      "Risk management balancing"
    ]
  },
  {
    title: "IT Governance & Oversight",
    description: "Ensuring outsourcing and consulting engagements stay accountable, aligned, and under executive control.",
    details: [
      "Board-level accountability",
      "Voice of dissent in hard decisions",
      "Executive control maintenance",
      "Vendor oversight",
      "Strategic alignment"
    ]
  }
];

export const experience = [
  {
    company: "Videre Scire Management Consulting Inc.",
    role: "vCIO, vCISO & IT Effectiveness Advisor",
    location: "Vancouver, BC / Blaine, WA",
    dates: "Nov 2025 - Present",
    responsibilities: [
      "Advising Paper Excellence Group on digital transformation, ERP optimization, and AI adoption strategies",
      "Oversight of $200M SAP S4/Hana migration and mitigation of mega-project risks",
      "Developed transitional services for Data Assurance Program during SaaS and cloud migration"
    ]
  },
  {
    company: "Paper Excellence Holdings",
    role: "Global Chief Information Officer & Information Security Officer (CI&SO)",
    location: "Richmond, BC",
    dates: "Aug 2020 – Nov 2025",
    team: "600+ FTEs",
    responsibilities: [
      "Overhauled IT infrastructure post-cyber breach during merger with Catalyst Paper",
      "Led global SAP hosting strategy and initiated $200M S4/Hana migration",
      "Implemented cybersecurity fabric blocking MITRE ATT&CK activities, reinstated cyber insurance",
      "Sponsored integration of Paper Excellence, Domtar, and Resolute, creating a $9B revenue business",
      "Established IT PMO managing 70+ projects and implemented global HRIS for 12,000 employees"
    ]
  },
  {
    company: "Videre Scire Management Consulting Inc.",
    role: "Digital Transformation & IT Effectiveness Advisor",
    location: "Vancouver, BC",
    dates: "Mar 2019 – Aug 2020",
    responsibilities: [
      "Advised mining and resource companies on ERP, IoT, and AI/ML strategies",
      "Delivered IT effectiveness assessments and project governance for large-scale digital transformations"
    ]
  },
  {
    company: "First Majestic Silver Corporation (NYSE: AG)",
    role: "Chief Transformation Officer (2015–2019); CIO & CISO (2012–2015)",
    location: "Vancouver, BC",
    dates: "2012 - Mar 2019",
    team: "2,000+ FTEs",
    responsibilities: [
      "Led cultural and digital transformation, returning company to profitability in two years",
      "Achieved $1.5M–$2M annual savings per mine through operational excellence programs",
      "Implemented SAP and 11 custom applications, reducing financial close times by 80%",
      "Migrated IT services to AWS, cutting hosting costs by 60%",
      "Introduced mineral processing automation, adding $1M/month to bottom line"
    ]
  },
  {
    company: "Goldcorp (NYSE: GG, now Newmont)",
    role: "Director of Global Applications & Director of IT Mexico",
    location: "Vancouver, BC",
    dates: "2008 - 2011",
    team: "13 + 650 Outsourced",
    responsibilities: [
      "Standardized SAP systems across 11 mining companies, reducing costs by 50%",
      "Designed global KPI dashboards, improving operational decision-making by 70%",
      "Reduced SAP support costs by 40% through CoE strategy"
    ]
  },
  {
    company: "The Jimmy Pattison Group",
    role: "Operations Improvement & IT Effectiveness – Technical Advisor",
    location: "Vancouver, BC",
    dates: "2006-2008",
    responsibilities: [
      "Managed largest system integration during a major merger, covering 46,000 stores and 9 distribution centers",
      "Implemented new ERP and logistics systems, saving $1M in transaction and due diligence fees"
    ]
  },
  {
    company: "KPMG Canada",
    role: "Senior Manager Advisory Consultant",
    location: "Vancouver, BC",
    dates: "2005-2006",
    responsibilities: [
      "Led IT effectiveness practice in Western Canada",
      "Closed $1M+ annual engagement with Pattison Group"
    ]
  }
];

export const achievements = [
  {
    category: "Global ERP Transformations",
    items: [
      "Led a $200M global migration to SAP S4/Hana for Paper Excellence Group, consolidating multiple ERP systems",
      "Migrated 15 M&A ERP systems into a single Oracle Financials global implementation for Seagate Software",
      "Re-implemented ERP (MS Dynamics) for Pivotal Software to support operations in 40 countries"
    ]
  },
  {
    category: "Cybersecurity Leadership",
    items: [
      "Designed and deployed a cybersecurity fabric post-cyber breach, reinstating cyber insurance and blocking multiple ethical hacking campaigns",
      "Conceived and implemented a Data Assurance program for real-time forensic tracking of critical data",
      "Developed practical cybersecurity strategies to block MITRE ATT&CK framework activities"
    ]
  },
  {
    category: "Business Turnarounds & Operational Excellence",
    items: [
      "Led First Majestic through digital and cultural transformation, returning to profitability in two years and saving $1.5M-$2M annually per mine",
      "Drove operational excellence at Goldcorp, standardizing SAP systems and reducing support costs 50%"
    ]
  },
  {
    category: "Strategic M&A Integration",
    items: [
      "Managed technical due diligence and systems integration for Pattison Group's largest merger, covering 46,000 stores and 9 distribution centers",
      "Migrated 15 M&A ERP systems into a single Oracle Financials global implementation for Seagate Software",
      "Standardized and consolidated 11 SAP ECC systems merging 3 large mining companies for Goldcorp"
    ]
  }
];

export const education = [
  {
    degree: "MBA",
    institution: "Royal Roads University",
    location: "Victoria, BC",
    specialization: "Executive Leadership & Knowledge Management"
  },
  {
    degree: "B.Sc. Math and Science",
    institution: "ITESM (Monterrey Institute of Higher Education)",
    location: "Mexico City"
  },
  {
    degree: "Associate of Science in Computer and Industrial Electronics (Robotics)",
    institution: "Santa Fe College",
    location: "Gainesville, FL"
  }
];

export const certifications = [
  "Certified Management Consultant (CMC)",
  "Certified Information Systems Auditor (CISA)",
  "Diploma, Digital Transformation (AI, IoT, Cloud Computing, Blockchain, Cyber Security) - MIT",
  "Diploma, Managing Technical Professionals and Organizations - MIT Sloan School of Management"
];

export const competencies = [
  "IT & Cybersecurity Strategy",
  "ERP & Digital Transformation",
  "Cloud & AI Adoption",
  "Derisking Mega Projects",
  "Operational Excellence",
  "M&A Integration",
  "Vision & Strategy",
  "Customer & Business Intelligence",
  "Margin Improvement",
  "Project Delivery",
  "Change Management"
];
